import React, { useEffect, useState } from 'react'
import { MdNotifications } from 'react-icons/md'
import { useSocketStore } from '../../store/socketStore'
import { useNavigate } from 'react-router-dom'
import { swalErrorAlert } from '../../utils/swal/swal'
import { adminGetNotificationApi, adminReadNotificationApi, getNotificationApi, readNotificationApi } from '../../api/notification'

const AlertIcon = ({ userInfo, isAdmin = false }) => {
  const { socket, initSocket, onNotification, offNotification } = useSocketStore()

  const [open, setOpen] = useState(false)
  const [notification, setNotification] = useState([])

  const navigate = useNavigate()

  useEffect(() => {
    if (!userInfo?.user_id) return

    // DB
    getNotification(userInfo?.user_id)

    // 소켓
    if (!socket) {
      initSocket(userInfo?.user_id)
    }
    onNotification((notification) => {
      setNotification((prev) => {
        const exist = prev.some((noti) => noti.type === notification.type)
        if (exist) {
          return prev
        } else {
          return [...prev, notification]
        }
      })
    })

    return () => {
      if (socket) {
        offNotification()
      }
    }
  }, [userInfo])

  const getNotification = async () => {
    if (!userInfo?.user_id) return

    try {
      let response
      if (isAdmin) {
        response = await adminGetNotificationApi(userInfo?.user_id)
      } else {
        response = await getNotificationApi(userInfo?.user_id)
      }

      if (response.data.code === 200) {
        const notificationData = response.data.resData

        setNotification(notificationData)
      }
    } catch (error) {
      console.log(error)
      swalErrorAlert('알림 에러', '알림 조회 도중 에러가 발생했습니다.')
      return
    }
  }

  const handleReadNotification = async (noti) => {
    const notiId = noti?.id
    const notiLink = noti?.link

    if (!notiId) return

    try {
      // notification is_read 변경
      if(isAdmin){
        await adminReadNotificationApi({ notiId })

      }else{
        await readNotificationApi({ notiId })

      }

      // setNotification 에서 현재 알림 지움
      setNotification((prev) => prev.filter((item) => item.id !== notiId))

      // 알림 탭 닫기
      setOpen(false)

      // 새탭으로 링크 이동
      if (notiLink) {
        if (isAdmin) {
          if (noti?.type === 'chat') { navigate('/hy-admin/chatting') }
        } else {
          navigate(notiLink)
        }
      }


    } catch (error) {
      console.log(error)
      swalErrorAlert('알림 에러', '알림 처리 도중 에러가 발생했습니다.')
      return
    }
  }

  return (
    <>
      <div className="alert-icon">
        <div
          className={notification.length > 0 ? 'icon active' : 'icon'}
          onClick={() => {
            setOpen(!open)
          }}>
          <MdNotifications size={'22px'} />
        </div>

        {open && (
          <div className='alert-modal'>
            {notification.length > 0 && (
              <ul className="alert-list">
                {notification.map((noti, index) => {
                  return (
                    <li key={'noti-' + index} onClick={() => handleReadNotification(noti)}>
                      {noti.content}
                    </li>
                  )
                })}
              </ul>
            )}

            {notification.length === 0 && <div>등록된 알림이 없습니다.</div>}
          </div>
        )}
      </div>
    </>
  )
}

export default AlertIcon
